import {Ticket} from "./Ticket";
import AbstractComment from "./AbstractComment";

export class WorkflowComment extends AbstractComment {
    workflowTicket: Ticket | string | null = null
}

export type WorkflowCommentType = WorkflowComment;